import styled from 'styled-components';
import { styledCTALink } from './StyledCTALink';
import { StyledRouterLink } from './StyledRouterLink';

export const StyledCTARouterLink = styled(StyledRouterLink)(styledCTALink);
